import type { CSSProperties } from "react";

/**
 * Canonical "card shell" used across the dashboard chart UI.
 *
 * This is the single source of truth for the bordered, rounded, gradient +
 * shadowed surface that wraps charts and dashboard cards. Both
 * `ChartContainer` and feature areas (e.g. insurance) import these so the
 * surface stays visually consistent and isn't duplicated per-feature.
 */
export const chartCardShellClass =
  "overflow-hidden rounded-card border border-primary/50";

/** Brand gradient + secondary-color shadow that matches `ChartContainer`. */
export const chartCardShellStyle: CSSProperties = {
  /* Soft teal card shadow — same token the Surface primitive uses */
  boxShadow: "var(--shadow-card)",
  /* Subtle gradient of the primary brand colour over the container background */
  background:
    "linear-gradient(0.27deg, rgb(var(--color-primary) / 0.1) 0.28%, rgb(var(--color-primary) / 0) 99.82%), var(--chart-container-bg, #FFFFFF)",
};
